<template>
  <div
    class="modal-window-wrapper d-flex-column-center position-absolute"
    style="z-index: 1050; width: clamp(100%, 50vw, 98vw)"
  >
    <Transition name="fade" appear>
      <div
        v-if="showModal"
        class="modal-window-overlay"
        @click="$emit('closeModal')"
      ></div>
    </Transition>
    <Transition name="pop" appear>
      <slot v-if="showModal" class="modal-window" />
    </Transition>
  </div>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
  },
  created() {
    const that = this
    document.addEventListener('keyup', function (event) {
      if (event.key == 27 || event.key == 'Escape' || event.code == 'Escape') {
        that.$emit('closeModal')
      }
    })
  },
}
</script>

<style scoped>
.modal-window-wrapper > div {
  z-index: 1050;
  width: 100%;
}

.modal-window {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  transform: none;
  z-index: 1050;
}
.modal-window-overlay {
  content: '';
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background: var(--bs-primary);
  opacity: 0.6;
  cursor: pointer;
}

.modal-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  place-content: center;
  place-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-40%);
}
</style>
